export const FEATURE_FLAGS = {
  // When true, partner-gated routes are accessible even without a partners row
  UNLOCK_PARTNER_ROUTES:
    (import.meta.env.VITE_UNLOCK_PARTNER_ROUTES ?? 'false')
      .toString()
      .toLowerCase() === 'true',
};
